import PhoneIcon from 'assets/icons/phone-icon.svg?component'
import FacebookIcon from 'assets/icons/socials/facebook.svg?component'
import InstagramIcon from 'assets/icons/socials/instagram.svg?component'
import WhatsappIcon from 'assets/icons/socials/whatsapp.svg?component'
import SVGIcon from 'components/UI/SvgIcon'
import ThemeToggle from 'components/UI/ThemeToggle'
import ToggleButtonGroup from 'components/UI/ToggleButtonGroup'
import Typography from 'components/UI/Typography'
import Heading from 'components/UI/Typography/Heading'
import { motion } from 'framer-motion'
import { useLanguageChange } from 'hooks/useLanguageChange'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import tw from 'twin.macro'
import { useLockedBody } from 'usehooks-ts'

import AppSteps from '../AppSteps'

const sidebar = {
  open: (height = 1000) => ({
    clipPath: `circle(${height * 2 + 200}px at 40px 40px)`,
    transition: {
      type: 'spring',
      stiffness: 20,
      restDelta: 2
    }
  }),
  closed: {
    clipPath: 'circle(5px at 30px 30px)',
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 40
    }
  }
}

const styles = {
  container: ({ isOpen }: { isOpen: boolean }) => [
    isOpen ? tw`absolute inset-x-0 top-[58px] pt-8 w-full h-full bg-main overflow-hidden z-20` : tw``
  ],
  sidebar: ({ isOpen }: { isOpen: boolean }) => [isOpen ? tw`` : tw`hidden`]
}

const Menu = ({ isOpen }: { isOpen: boolean }) => {
  //Tools
  const { t } = useTranslation('common')

  // Hooks
  const { language, onLangChange } = useLanguageChange()
  useLockedBody(isOpen)

  return (
    <motion.div css={styles.container({ isOpen })} initial={false}>
      <motion.div css={styles.sidebar({ isOpen })} variants={sidebar}>
        <div tw='px-[1.25rem] pb-1 '>
          <div tw='flex justify-between'>
            <ThemeToggle twStyle={tw`mr-6`} />
            <ToggleButtonGroup
              value={language}
              btnStyle={tw`py-2 px-3 rounded-lg`}
              containerStyles={tw`px-6`}
              options={[
                {
                  value: 'ru',
                  content: (
                    <Fragment>
                      <Typography variant='subbody' weight='bold'>
                        Рус
                      </Typography>
                    </Fragment>
                  )
                },
                {
                  value: 'kk',
                  content: (
                    <Fragment>
                      <Typography variant='subbody' weight='bold'>
                        Каз
                      </Typography>
                    </Fragment>
                  )
                }
              ]}
              onChange={onLangChange}
            />
          </div>
          <hr tw='mt-[26px] mb-[24px] border-grey-middle' />
          <AppSteps twStyle={tw`visible`} />
          <hr tw='my-[24px] border-grey-middle' />
          <div tw='visible flex space-x-6'>
            <div tw='flex flex-col'>
              <div tw='flex space-x-2 items-center'>
                <PhoneIcon tw='flex-shrink-0' />
                <a href='tel:595'>
                  <Heading variant='title2' as='h6' twStyle={tw`text-[30px] leading-[40.86px] tracking-[-0.35px]`}>
                    595
                  </Heading>
                </a>
              </div>
              <Typography variant='caption' twStyle={tw`text-grey-dark text-[14px] leading-[18px] tracking-[-0.15px]`}>
                {t('free-call')}
              </Typography>
            </div>
          </div>
          <hr tw='my-[24px] border-grey-middle' />
          <div aria-label='socials' tw='flex space-x-2 '>
            <a href='https://www.instagram.com/bankffin.kz/' target='_blank' rel='noreferrer'>
              <SVGIcon>
                <InstagramIcon tw='flex-shrink-0' width={18} height={18} />
              </SVGIcon>
            </a>
            <a href='https://api.whatsapp.com/send?phone=77761595595' target='_blank' rel='noreferrer'>
              <SVGIcon>
                <WhatsappIcon tw='flex-shrink-0' width={18} height={18} />
              </SVGIcon>
            </a>
            <a href='https://www.facebook.com/bankffin.kz' target='_blank' rel='noreferrer'>
              <SVGIcon>
                <FacebookIcon tw='flex-shrink-0' width={18} height={18} />
              </SVGIcon>
            </a>
          </div>
        </div>
      </motion.div>
    </motion.div>
  )
}

export default Menu
